var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"community-topic-categories"},[_c('action-dispatcher',{attrs:{"action":"community/getCategories"}},[_c('h6',{staticClass:"mt-4"},[_vm._v("Categorias")]),_c('router-link',{staticClass:"btn",class:{
        'btn-primary': _vm.$route.name === 'community' && !_vm.$route.query.category,
        'btn-dark': _vm.$route.name !== 'community' || !!_vm.$route.query.category
      },attrs:{"to":{
        name: 'community',
        query: {}
      }}},[_vm._v(" Todas ")]),_vm._l((_vm.categories),function(category){return _c('router-link',{key:category.id,staticClass:"btn",class:{
        'btn-primary': _vm.$route.query.category === category.id,
        'btn-dark': _vm.$route.query.category !== category.id
      },attrs:{"to":{
        name: 'community',
        query: { category: category.id }
      }}},[_vm._v(" "+_vm._s(category.name)+" ")])})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }